import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('usuario');
    navigate('/');
  };

  return (
    <nav className="navbar is-primary" role="navigation" aria-label="main navigation">
      <div className="navbar-brand">
        <Link to="/dashboard" className="navbar-item">
          🎫 Sistema Casino
        </Link>
        <button className="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarMenu">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </button>
      </div>

      <div id="navbarMenu" className="navbar-menu">
        <div className="navbar-start">
          <Link to="/dashboard" className="navbar-item">Dashboard</Link>
          <Link to="/tickets" className="navbar-item">Tickets</Link>
          <Link to="/tickets-por-area" className="navbar-item">Por Área</Link>
          <Link to="/buscar-rut" className="navbar-item">Buscar RUT</Link>
          <Link to="/crear-personal" className="navbar-item">Crear Personal</Link>
          <Link to="/listar-personal" className="navbar-item">Ver Personal</Link>
          <Link to="/almuerzos" className="navbar-item">Ver Almuerzos</Link>
          <Link to="/cargar-programacion" className="navbar-item">Cargar Programacion</Link>
          <Link to="/pronostico" className="navbar-item">Pronostico Mes</Link>
          
        </div>

        <div className="navbar-end">
          <div className="navbar-item">
            <button className="button is-light" onClick={handleLogout}>Cerrar Sesión</button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
